
<!--ng-container *ngIf="user.isProMember == 1 && user.expdays < 31 ">
        <div class="renewal-banner"><div class="renwal-text">Your Subscription is expiring in {{daysText}}. Renew and save 20%!</div></div>
</!--ng-container>
<ng-container *ngIf="user.isProMember == 2 ">
    <div class="renewal-banner"><div class="renwal-text">Your subscription has expired. Renew Now!</div></div>
</ng-container -->



<ng-container *ngIf="data.version!=2; else version2">
    <ol itemscope itemtype="https://schema.org/BreadcrumbList" class='flex-fs-c m-t-10 p-0-i hide-brd-sm' *ngIf="!global.isMobile()">
        <ng-container *ngFor="let item of breadcrumb; let i=index">
            <li *ngIf="item.link!=undefined && item.link!=''" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class='block'>
                <a itemprop="item" [routerLink]="item.link" class='capitalize hover-underline'>
                    <span itemprop="name">{{item.name}}</span>
                </a>
                <meta itemprop="position" [content]="i+1"/>
            </li>
            <li *ngIf="item.link==undefined || item.link==''" class='block'>
                <span class='capitalize'>{{item.name}}</span>
            </li>
            <li *ngIf="i<(breadcrumb.length-1)" class='block'>
                <span class='text-muted'>&nbsp;/&nbsp;</span>
            </li>
        </ng-container>
    </ol>
</ng-container>
<ng-template #version2>
    <ol itemscope itemtype="https://schema.org/BreadcrumbList" class='flex-fs-c m-t-10 p-0-i hide-brd-sm' >
        <ng-container *ngFor="let item of breadcrumb; let i=index">
            <li *ngIf="item.link!=undefined && item.link!=''" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class='block'>
                <a itemprop="item" [routerLink]="item.link" class='capitalize brd-item'>
                    <span itemprop="name"  class="hovercolor">{{item.name}}</span>
                </a>
                <meta itemprop="position" [content]="i+1"/>
            </li>
            <li *ngIf="item.link==undefined || item.link==''" class='block' >
                <span class='capitalize brd-item' >{{item.name}}</span>
            </li>
            <li *ngIf="i<(breadcrumb.length-1)" class='block' >
                <span class='text-muted brd-item' >&nbsp;/&nbsp;</span>
            </li>
        </ng-container>
    </ol>
</ng-template>
